module.exports = __webpack_public_path__ + "static/blog-3-68cc81bec7484cc9be5252b72ee61496.jpg";